import { Component, OnInit } from '@angular/core';
import { AppConfigService } from '@core/services/config.service';
import { LocalStorageService } from 'ngx-webstorage';
import { Router } from '@angular/router';
@Component({
    selector: 'app-step1-thank',
    templateUrl: './step1-thank.component.html',
    styleUrls: ['./step1-thank.component.scss']
})
export class AppStep1ThankComponent implements OnInit {
    code: string;
    name: string;
    constructor(
        private _appConfig: AppConfigService,
        private _storage: LocalStorageService,
        private _router: Router
    ) {
        this._appConfig.setSettings({
            layout: {
                header: {
                    home: false,
                    register: true,
                    fixed: true
                },
                footer: {
                    home: false,
                    register: true,
                    fixed: true
                }
            }
        });
        if (this._storage.retrieve('lead')) {
            const lead = this._storage.retrieve('lead');
            this.name = lead.contact_name;
        }
    }

    ngOnInit() {
        (window as any).fbq('track', 'CompleteRegistration');
    }

    go() {
        if (this._storage.retrieve('token')) {
            const code = this._storage.retrieve('code');
            this._router.navigate([`/local/registro/2/${code}`]);
        } else {
            this._router.navigate([`/auth/register`]);
        }
    }
}
